import { useLocale } from 'next-intl';
import { useEffect } from 'react';

import { EventType } from '@/analytics/types';
import { BUSINESS_PATHNAME } from '@/app/consts/pathnames';
import isBrowser from '@/utils/isBrowser';

import { hubspotFormStyles } from './hubspotFormStyles';

interface HubspotFormProps {
  readonly formId: string;
}

const HubspotForm = ({ formId }: HubspotFormProps): JSX.Element => {
  const locale = useLocale();
  const wrapperId = `hs-form-wrapper-${formId}`;

  useEffect(() => {
    if (isBrowser()) {
      window.hbspt.forms.create({
        cssRequired: hubspotFormStyles,
        formId,
        locale,
        portalId: '7217787',
        region: 'na1',
        target: `#${wrapperId}`,
        onFormSubmitted: () => {
          void window.ouraAnalytics.track(EventType.B2bModalCompleted, {
            action: 'submit form',
            cta: 'submit',
            location: 'B2B lead capture modal',
            path: BUSINESS_PATHNAME,
          });
        },
      });
    }
  }, [formId, locale, wrapperId]);

  return <div id={wrapperId} data-cy="business-hubspot-form" />;
};

export default HubspotForm;
